module.exports = __webpack_public_path__ + "img/black_fishing_a001_title.0ea947cc.png";